import * as React from "react";
const SvgNanobanana = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_5164_8451)" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M90.442 148.249C44.1628 200.098 30.279 255.651 48.7907 314.907C67.3024 374.164 104.326 420.457 159.861 453.789C233.908 472.307 307.954 463.048 382.001 426.013C456.048 388.978 483.815 333.425 465.304 259.355C446.792 166.767 400.513 101.955 326.466 64.9201C252.419 27.8849 173.745 55.6613 90.442 148.249Z",
      fill: "url(#paint0_linear_5164_8451)",
      stroke: "#FCBF49",
      strokeWidth: 8
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      opacity: 0.6,
      d: "M132.256 176.07C95.257 209.388 81.3823 246.407 90.6321 287.128C99.8819 327.849 127.631 355.613 173.88 370.42C220.129 379.675 271.003 375.048 326.502 356.538C382 338.029 405.125 305.637 395.875 259.363C386.625 194.58 354.251 148.306 298.752 120.542C243.254 92.7775 187.755 111.287 132.256 176.07Z",
      fill: "#FFF3B8"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M159.857 398.191C215.347 416.667 280.086 416.667 354.073 398.191C428.06 379.715 455.805 352 437.308 315.048C418.811 333.524 391.066 352 354.073 370.476C317.079 388.953 252.341 398.191 159.857 398.191Z",
      fill: "url(#paint1_linear_5164_8451)"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      opacity: 0.8,
      d: "M215.357 276.048C224.47 276.048 231.857 268.661 231.857 259.548C231.857 250.435 224.47 243.048 215.357 243.048C206.244 243.048 198.857 250.435 198.857 259.548C198.857 268.661 206.244 276.048 215.357 276.048Z",
      fill: "#FCBF49"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      opacity: 0.8,
      d: "M270.857 304.048C280.246 304.048 287.857 296.437 287.857 287.048C287.857 277.659 280.246 270.048 270.857 270.048C261.468 270.048 253.857 277.659 253.857 287.048C253.857 296.437 261.468 304.048 270.857 304.048Z",
      fill: "#FCBF49"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      opacity: 0.8,
      d: "M326.357 276.048C335.47 276.048 342.857 268.661 342.857 259.548C342.857 250.435 335.47 243.048 326.357 243.048C317.244 243.048 309.857 250.435 309.857 259.548C309.857 268.661 317.244 276.048 326.357 276.048Z",
      fill: "#FCBF49"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      opacity: 0.5,
      d: "M214.857 259.048L270.857 287.048L326.857 259.048",
      stroke: "#F77F00",
      strokeWidth: 2
    }
  )),
  /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement(
    "linearGradient",
    {
      id: "paint0_linear_5164_8451",
      x1: 40.8571,
      y1: 49.0479,
      x2: 41411.1,
      y2: 43018.2,
      gradientUnits: "userSpaceOnUse"
    },
    /* @__PURE__ */ React.createElement("stop", { stopColor: "#FFE066" }),
    /* @__PURE__ */ React.createElement("stop", { offset: 0.5, stopColor: "#FFD23F" }),
    /* @__PURE__ */ React.createElement("stop", { offset: 1, stopColor: "#FCBF49" })
  ), /* @__PURE__ */ React.createElement(
    "linearGradient",
    {
      id: "paint1_linear_5164_8451",
      x1: 159.857,
      y1: 315.048,
      x2: 159.857,
      y2: 10015,
      gradientUnits: "userSpaceOnUse"
    },
    /* @__PURE__ */ React.createElement("stop", { stopColor: "#F77F00", stopOpacity: 0.3 }),
    /* @__PURE__ */ React.createElement("stop", { offset: 1, stopColor: "#D62828", stopOpacity: 0.1 })
  ), /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_5164_8451" }, /* @__PURE__ */ React.createElement("rect", { width: 512, height: 512, fill: "white" })))
);
export default SvgNanobanana;
